import { IGetAllCentroCustoEnderecoUseCase } from "../../../presentation/useCases/read/get_all_centro_custo_endereco_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";
import { CentroCustoEndereco } from "../../models/centro_custo_endereco";

/**
 * GetAllCentroCustoEnderecoUseCase
 */

export class GetAllCentroCustoEnderecoUseCase extends BasePaginatedUseCase<CentroCustoEndereco> implements IGetAllCentroCustoEnderecoUseCase {
  constructor(private readonly repository: IComercialRepository) {
    super();
  }

  async getAllCentroCustoEndereco(
    page: number,
    rowsPerPage: number,
    idCentroCusto: number
  ): Promise<void> {
    const response = await this.repository.getAllCentroCustoEndereco(
      page,
      rowsPerPage,
      idCentroCusto
    );
    this._items = response.items;
    this._pageSize = response.pageSize;
    this._currentPage = response.currentPage;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }


}
